import {useSelector} from "react-redux";
import _ from "lodash";
import moment from "moment";
import React from "react";

export const filterMessagesForChat = (messages, otherTagOwnerId) => {
  return messages.filter((message) => (message.receiver_tag_owner_id === otherTagOwnerId || message.sender_tag_owner_id === otherTagOwnerId))
}

export const groupMessages = (messages) => {
  let groupedMessages = []
  messages.forEach((message) => {
    let lastMessage = groupedMessages[groupedMessages.length - 1]
    if (groupedMessages.length > 0 && lastMessage && lastMessage.tagOwnerId === message.sender_tag_owner_id) {
      // if a message was deleted the id should change so react knows about it
      lastMessage.id += message.id
      lastMessage.body += "\n" + message.body
      lastMessage.read_at = message.read_at
    } else {
      groupedMessages.push({
        id: message.id,
        name: message.sender_tag_owner.name,
        tagOwnerId: message.sender_tag_owner.id,
        tagOwner: message.sender_tag_owner,
        body: message.body,
        read_at: message.read_at
      })
    }
  })
  return groupedMessages
}

/**
 * Gets all unread messages.
 *
 * NOTICE: If there are changes to the logic of unread messages, this must also be changed in the beforeunload for the beacon.
 *
 * @param tagOwnerId Can be null, if set only messages received from the tag owner if the given tagOwnerId.
 * @return Returns all unread messages
 */
export const useUnreadMessages = (tagOwnerId) => {
  const tagOwner = useSelector((state) => state.tagOwner)
  const messages = useSelector((state) => state.directMessaging.messages)
  const readMessageIds = useSelector((state) => state.directMessaging.readMessageIds)

  if (messages) {
    return messages.filter((message) => !message.read_at && message.receiver_tag_owner_id === tagOwner.id && (message.sender_tag_owner_id === tagOwnerId || !tagOwnerId) && readMessageIds.indexOf(message.id) === -1);
  }

  return []
}

/**
 * Groups all chat messages of the state.tagOwner into chats (groups for every tag owner they got written or wrote too).
 *
 * @return Returns a list of all the chats (chat messages grouped by the peer tag owner id).
 */
export const useChats = () => {
  const tagOwner = useSelector((state) => state.tagOwner)
  const messages = useSelector((state) => state.directMessaging?.messages || [])

  const filteredMessages = messages.filter((message) => message)
  const orderedMessages = _.orderBy(filteredMessages, message => moment(message.created_at), "desc")

  return _(orderedMessages)
    .groupBy(message => message.sender_tag_owner_id === tagOwner.id ? message.receiver_tag_owner_id : message.sender_tag_owner_id)
    .map((value, key) => ({
      tagOwner: value[0]?.sender_tag_owner_id === tagOwner.id ? value[0]?.receiver_tag_owner : value[0]?.sender_tag_owner,
      messages: value,
      read_at: value.slice(-1)[0].read_at
    })).value();
}

/**
 * Renders chat message body so links are not displayed as plain text, but instead as links.
 *
 * @param body The raw chat message body
 * @returns Returns JSX where links are replaced with actual links.
 */
export const renderChatMessageBody = (body) => {
  const linkRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
  return body.split(linkRegex).map((part, index) => {
    return (index % 2 === 0 ? part : <a href={part} className={"chat-message-link"} target="_blank">{part}</a>)
  })
}